define('helperUser-getAnswer',[],function() {
    'use strict';

    var getAnswer = function getAnswer(userData, contentEntityId) {
        var i           = 0,
            userAnswers = userData.answers,
            len         = userAnswers.length;

        while (i < len) {
            if ( userAnswers[i].contentEntityId === contentEntityId ) {
                var answer = userAnswers[i];
                return answer;
            }
            i++;
        }

        // console.log("Answer not found for "+ contentEntityId +"!");
        return null;
    };

    return getAnswer;
});

